import { createContext, type Dispatch, type PropsWithChildren, type SetStateAction, useMemo } from 'react'
import { type TenantId } from './tenant-ids'

export type TenantContextValue = {
  tenant: TenantId
  setTenant: Dispatch<SetStateAction<TenantId>>
}

const noopSetTenant: Dispatch<SetStateAction<TenantId>> = () => {}

export const TenantContext = createContext<TenantContextValue>({
  tenant: 'dhl',
  setTenant: noopSetTenant,
})

export const TenantContextProvider = ({ tenant, setTenant, children }: PropsWithChildren<TenantContextValue>) => {
  const contextValue = useMemo(() => ({ tenant, setTenant }), [tenant, setTenant])

  return <TenantContext.Provider value={contextValue}>{children}</TenantContext.Provider>
}
